import React from 'react';
import { classes, useRedirect } from '../../../../lib';
import { Affix } from 'antd';
import Styles from './TrainingMenu.module.less';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronDown,
    faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import {
    TRAINING_URL,
    getTrainingCurrentSlug,
} from '../../../../lib/landingPage/training';
import {
    TrainingDataType,
    TrainingMenuItemType,
} from '../../../../lib/landingPage';

type TrainingMenuItemProps = {
    item: TrainingMenuItemType;
    currentKey: string;
    setCurrentKey: (key: string) => void;
};

const TrainingMenuItem = ({
    item,
    currentKey,
    setCurrentKey,
}: TrainingMenuItemProps) => {
    const redirect = useRedirect();
    const selectedKeyIsChild = (currentItem: TrainingMenuItemType): boolean => {
        if (currentKey === currentItem.content.slug.current) {
            return true;
        }
        if (currentItem.children) {
            return currentItem.children.some(i => selectedKeyIsChild(i));
        }
        return false;
    };
    const defaultExpanded = selectedKeyIsChild(item);

    const [expanded, setExpanded] = React.useState<boolean>(defaultExpanded);

    const expandable = Boolean(item.children);
    return (
        <div className="vertical">
            <div className="vertical">
                <div
                    className={classes(
                        Styles.menuItem,
                        'horizontal left-middle g4 p4',
                        currentKey === item.content.slug.current
                            ? Styles.menuItemSelected
                            : ''
                    )}
                    onClick={() => {
                        redirect(
                            `${TRAINING_URL()}/${item.content.slug.current}`
                        );
                        if (expandable) {
                            setExpanded(true);
                        }
                        setCurrentKey(item.content.slug.current);
                    }}>
                    <span>{item.title}</span>
                    {expandable && (
                        <FontAwesomeIcon
                            className={Styles.expandIcon}
                            icon={expanded ? faChevronDown : faChevronRight}
                            onClick={e => {
                                e.stopPropagation();
                                setExpanded(!expanded);
                            }}
                        />
                    )}
                </div>
                {expanded && (
                    <div className="vertical g4 pl8">
                        {item.children?.map(c => (
                            <TrainingMenuItem
                                key={c._key}
                                item={c}
                                currentKey={currentKey}
                                setCurrentKey={setCurrentKey}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export const TrainingMenuContent = ({ trainingMenu }: TrainingMenuProps) => {
    const [currentKey, setCurrentKey] = React.useState<string>(
        getTrainingCurrentSlug()
    );

    return (
        <>
            {trainingMenu.items.map(tm => {
                return (
                    <div className="vertical g4" key={tm._key}>
                        <span className="small-semibold-alude text-uppercase alude-gray-9 px4">
                            {tm.title}
                        </span>
                        <div className="vertical g4 regular-alude alude-gray-7">
                            {tm.items.map(item => (
                                <TrainingMenuItem
                                    key={item._key}
                                    item={item}
                                    currentKey={currentKey}
                                    setCurrentKey={setCurrentKey}
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export type TrainingMenuProps = {
    trainingMenu: TrainingDataType;
};

export const TrainingMenu = ({ trainingMenu }: TrainingMenuProps) => {
    return (
        <Affix className={classes(Styles.leftMenu, 'm-hidden')}>
            <div className="vertical g16">
                <div
                    className={classes(
                        Styles.menuContainer,
                        'vertical g16 p16'
                    )}>
                    <TrainingMenuContent trainingMenu={trainingMenu} />
                </div>
            </div>
        </Affix>
    );
};
